export const color = {
  paleOrange: '#FFDFBF',
  veryPaleOrange: '#FFF9F2',
  orange: '#F0852D',
  lightBlue: '#DBF0FE',
  darkBlue: '#003366'
};

export const size = {
  tiny: '0.5rem',
  extraSmall: '1rem',
  small: '1.5rem',
  medium: '2rem',
  large: '3rem',
  extraLarge: '4rem',
  long: '50rem',
  tall: '10rem',
  maxWidth: '800px',
  minWidth: '700px'
};

export const layout = {
  margin: '100px',
  maxWidth: '800px',
  mediaWidth: '700px'
}

export const fontWeight = {
  extraLightWeight: 200,
  lightWeight: 300,
  mediumWeight: 500,
  heavyWeight: 800
};

const theme = {
  color,
  size,
  fontWeight
};

export default theme;